import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DocumentService } from '../../services/document.service';

@Component({
  selector: 'app-settings',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule],
  template: `
    <div class="app-layout">
      <!-- Navbar -->
      <nav class="navbar glass">
        <div class="logo">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
          SignDoc Pro
        </div>
        <div class="nav-links">
          <a routerLink="/launcher" class="back-link">
            <svg viewBox="0 0 24 24" width="18" height="18" stroke="currentColor" stroke-width="2" fill="none"><polyline points="15 18 9 12 15 6"></polyline></svg>
            Hub
          </a>
          <a routerLink="/pdf-signer">Dashboard</a>
          <a routerLink="/pdf-signer/contacts">Kontakte</a>
          <a routerLink="/pdf-signer/settings" class="active">Einstellungen</a>
        </div>
        <div class="avatar">YS</div>
      </nav>

      <main class="main-content">
        <div class="settings-container glass-panel">
          <div class="settings-header">
            <h2>E-Mail (SMTP) Einstellungen</h2>
            <p>Konfigurieren Sie hier Ihren eigenen SMTP-Server, um E-Mails anstelle des internen Test-Systems zu versenden.</p>
          </div>

          <div class="settings-body">
            <div class="form-group">
              <label>SMTP Host</label>
              <input type="text" [(ngModel)]="settings.smtpHost" class="modern-input" placeholder="z.B. smtp.strato.de">
            </div>

            <div class="form-group">
              <label>SMTP Port</label>
              <input type="number" [(ngModel)]="settings.smtpPort" class="modern-input" placeholder="z.B. 465">
            </div>

            <div class="form-group">
              <label>Benutzername</label>
              <input type="text" [(ngModel)]="settings.smtpUser" class="modern-input" placeholder="info@deine-firma.de">
            </div>

            <div class="form-group">
              <label>Passwort</label>
              <input type="password" [(ngModel)]="settings.smtpPassword" class="modern-input" placeholder="Dein SMTP Passwort">
            </div>

            <div class="form-group">
              <label>Absender-Adresse (From)</label>
              <input type="text" [(ngModel)]="settings.smtpFrom" class="modern-input" placeholder='"SignDoc" <info@deine-firma.de>'>
            </div>

            <div class="action-buttons">
              <button class="btn-primary" (click)="saveSettings()" [disabled]="isSaving">
                {{ isSaving ? 'Speichern...' : 'Einstellungen speichern' }}
              </button>
            </div>
          </div>

          <div class="test-section">
            <h3>Verbindung testen</h3>
            <p>Senden Sie eine Test-E-Mail an sich selbst, um die Konfiguration zu überprüfen.</p>
            
            <div class="test-form">
              <input type="email" [(ngModel)]="testEmail" class="modern-input" placeholder="Ihre E-Mail Adresse">
              <button class="btn-secondary" (click)="runTest()" [disabled]="isTesting || !testEmail">
                {{ isTesting ? 'Wird gesendet...' : 'Test-Mail senden' }}
              </button>
            </div>

            <div class="alert success" *ngIf="testResult === 'success'">
              Test erfolgreich! E-Mail wurde versendet.
            </div>
            <div class="alert error" *ngIf="testResult === 'error'">
              Fehler beim Senden. Bitte überprüfen Sie Ihre Daten.
            </div>
          </div>
        </div>
      </main>
    </div>
  `,
  styles: [`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

    :host {
      font-family: 'Inter', sans-serif;
      display: block;
      min-height: 100vh;
      background-color: #0f172a;
      color: #f8fafc;
    }

    .app-layout { display: flex; flex-direction: column; min-height: 100vh; }
    
    .glass {
      background: rgba(15, 23, 42, 0.7);
      backdrop-filter: blur(12px);
      border-bottom: 1px solid rgba(255,255,255,0.05);
    }

    .glass-panel {
      background: rgba(30, 41, 59, 0.5);
      backdrop-filter: blur(16px);
      border: 1px solid rgba(255,255,255,0.05);
      border-radius: 1.5rem;
    }

    .navbar {
      display: flex; justify-content: space-between; align-items: center;
      padding: 1rem 3rem; position: sticky; top: 0; z-index: 100;
    }

    .logo {
      font-size: 1.25rem; font-weight: 700; display: flex; align-items: center; gap: 0.5rem;
      color: #f8fafc;
    }
    .logo svg { color: #38bdf8; }

    .nav-links { display: flex; gap: 2rem; }
    .nav-links a { color: #94a3b8; text-decoration: none; font-weight: 500; transition: color 0.2s; display: flex; align-items: center; gap: 0.25rem; }
    .nav-links a:hover, .nav-links a.active { color: #38bdf8; }
    .back-link { border-right: 1px solid rgba(255,255,255,0.1); padding-right: 1.5rem; margin-right: 0.5rem; }

    .avatar {
      width: 40px; height: 40px; border-radius: 50%;
      background: linear-gradient(135deg, #38bdf8, #818cf8);
      display: flex; align-items: center; justify-content: center;
      font-weight: 700; color: white;
    }

    .main-content {
      flex: 1; padding: 3rem; max-width: 800px; margin: 0 auto; width: 100%; box-sizing: border-box;
    }

    .settings-container { padding: 3rem; }
    .settings-header { border-bottom: 1px solid rgba(255,255,255,0.05); padding-bottom: 1.5rem; margin-bottom: 1.5rem; }
    .settings-header h2 { margin: 0 0 0.5rem; font-size: 1.5rem; color: #f8fafc; }
    .settings-header p { margin: 0; color: #94a3b8; }

    .settings-body { display: flex; flex-direction: column; gap: 1.25rem; }

    .form-group { display: flex; flex-direction: column; gap: 0.5rem; }
    .form-group label { font-size: 0.875rem; font-weight: 500; color: #cbd5e1; }
    
    .modern-input {
      width: 100%; box-sizing: border-box; padding: 0.75rem 1rem; border-radius: 0.5rem;
      background: rgba(15, 23, 42, 0.8); border: 1px solid rgba(255,255,255,0.1);
      color: white; font-family: 'Inter', sans-serif; font-size: 1rem;
      transition: border-color 0.2s ease;
    }
    .modern-input:focus { outline: none; border-color: #38bdf8; }

    .action-buttons { margin-top: 1rem; }

    .btn-primary {
      padding: 0.75rem 1.5rem; border-radius: 0.5rem; border: none;
      background: linear-gradient(135deg, #0ea5e9, #4f46e5); color: white;
      font-weight: 600; cursor: pointer; transition: all 0.2s ease;
    }
    .btn-primary:hover:not([disabled]) { opacity: 0.9; transform: translateY(-1px); box-shadow: 0 10px 15px -3px rgba(14, 165, 233, 0.3); }
    .btn-primary[disabled] { opacity: 0.5; cursor: not-allowed; filter: grayscale(1); }

    .test-section { margin-top: 3rem; padding-top: 2rem; border-top: 1px solid rgba(255,255,255,0.05); }
    .test-section h3 { margin: 0 0 0.5rem; font-size: 1.25rem; }
    .test-section p { color: #94a3b8; margin: 0 0 1.5rem; }

    .test-form { display: flex; gap: 1rem; margin-bottom: 1.5rem; }
    .test-form input { flex: 1; }

    .btn-secondary {
      padding: 0.75rem 1.5rem; border-radius: 0.5rem; border: 1px solid rgba(255,255,255,0.2);
      background: transparent; color: white; font-weight: 500; cursor: pointer; transition: all 0.2s ease;
    }
    .btn-secondary:hover:not([disabled]) { background: rgba(255,255,255,0.05); }
    .btn-secondary[disabled] { opacity: 0.5; cursor: not-allowed; }

    .alert { padding: 1rem; border-radius: 0.5rem; font-size: 0.875rem; font-weight: 500; margin-top: 1rem; }
    .alert.success { background: rgba(52, 211, 153, 0.1); border: 1px solid rgba(52, 211, 153, 0.2); color: #34d399; }
    .alert.error { background: rgba(248, 113, 113, 0.1); border: 1px solid rgba(248, 113, 113, 0.2); color: #f87171; }
  `]
})
export class SettingsComponent implements OnInit {
  settings: any = {};
  isSaving = false;
  
  testEmail = '';
  isTesting = false;
  testResult: 'none' | 'success' | 'error' = 'none';

  private documentService = inject(DocumentService);

  ngOnInit() {
    this.documentService.getSmtpSettings().subscribe({
      next: (res) => this.settings = res || {},
      error: (err) => console.error('Failed to load settings', err)
    });
  }

  saveSettings() {
    this.isSaving = true;
    this.documentService.saveSmtpSettings(this.settings).subscribe({
      next: () => {
        this.isSaving = false;
        alert('Einstellungen erfolgreich gespeichert!');
      },
      error: () => {
        this.isSaving = false;
        alert('Fehler beim Speichern');
      }
    });
  }

  runTest() {
    this.isTesting = true;
    this.testResult = 'none';
    this.documentService.testSmtp(this.testEmail).subscribe({
      next: (res) => {
        this.isTesting = false;
        this.testResult = 'success';
        if (res.previewUrl) {
          console.log('Preview URL:', res.previewUrl);
        }
      },
      error: () => {
        this.isTesting = false;
        this.testResult = 'error';
      }
    });
  }
}
